import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { RouterLink } from '@angular/router';
import { CarouselComponent } from 'src/app/layouts/carousel/carousel.component';
import Swal from 'sweetalert2';
import { JobOfferService } from 'src/app/services/job-offer.service';
import { AlertService } from 'src/app/services/alert.service';
import {
  GetJobOffer,
  GetJobOfferFilter,
} from 'src/app/models/job-offer/get-job-offer';
import { Paged } from 'src/app/models/shared/paged';
import { FormsModule } from '@angular/forms';
import { AuthService } from 'src/app/services/auth.service';
import { PaginationComponent } from '../../pagination/pagination.component';
import { JobOfferCardComponent } from '../../shared/job-offer-card/job-offer-card.component';
import { ViewModalEnum } from 'src/app/enums/operation';
import { FileStorageService } from 'src/app/services/file-storage.service';
import {
  ViewTrackingService,
  ViewType,
} from 'src/app/services/view-tracking.service';
import { ViewCountBaseService } from 'src/app/services/view-count-base.service';

@Component({
  selector: 'app-job-offer-companies',
  templateUrl: './job-offer-companies.component.html',
  styleUrl: './job-offer-companies.component.css',
  standalone: true,
  imports: [
    CommonModule,
    CarouselComponent,
    RouterLink,
    FormsModule,
    PaginationComponent,
    JobOfferCardComponent,
  ],
})
export class JobOfferCompaniesComponent implements OnInit {
  items: GetJobOffer[] = [];
  isLoading = false;
  page = 1;
  pageSize = 5;
  totalItems = 0;
  userId: number | null = null;

  viewEnums = ViewModalEnum;

  selectedJobUrl: string = '';

  constructor(
    private jobOfferService: JobOfferService,
    private alertService: AlertService,
    private authService: AuthService,
    private docService: FileStorageService,
    private viewTrackingService: ViewTrackingService,
    private viewCountService: ViewCountBaseService
  ) {}

  ngOnInit(): void {
    this.userId = this.authService.getUserId();
    this.loadData();
  }

  loadData(): void {
    this.isLoading = true;
    const filter: GetJobOfferFilter = {
      page: this.page,
      pageSize: this.pageSize,
      filterKey: 'ownerUserId',
      filterValue: this.userId ? this.userId.toString() : null,
    };
    this.jobOfferService
      .getList(filter)
      .subscribe({
        next: (res) => {
          this.items = res.items.map((x) => {
            return {
              ...x,
              logoUrl: x.logoFileId
                ? this.docService.getFileUrl(`${x.logoFileId}`)
                : null,
            };
          });
          this.totalItems = res.totalItems;
          this.loadViewCounts(); // Cargar conteos de vistas
        },
        error: () => {
          this.alertService.showErrorAlert(
            'Error al cargar las ofertas laborales'
          );
        },
      })
      .add(() => {
        this.isLoading = false;
      });
  }

  deleteJob(id: number): void {
    Swal.fire({
      title: 'Eliminar',
      text: '¿Desea eliminar la oferta de empleo?',
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#0d1174',
      cancelButtonColor: '#3a3a3a',
      confirmButtonText: 'Eliminar',
    }).then((resultmodal) => {
      if (resultmodal.isConfirmed) {
        this.isLoading = true;
        this.jobOfferService
          .deleteJobOffer(id)
          .subscribe({
            next: () => {
              this.alertService.showSuccessAlert(
                'Oferta eliminada correctamente'
              );
              this.loadData();
            },
            error: () => {
              this.alertService.showErrorAlert('Error al eliminar la oferta');
            },
          })
          .add(() => {
            this.isLoading = false;
          });
      }
    });
  }

  loadViewCounts(): void {
    this.viewCountService.loadViewCountsDirectly(this.items, ViewType.JobOffer);
  }

  onPageChange(value: number): void {
    this.page = value;
    this.loadData();
  }

  onPageSizeChange(value: number): void {
    this.pageSize = value;
    this.page = 1;
    this.loadData();
  }

  openShareModal(item: any): void {
    // Safely get origin, fallback to empty string in SSR
    const origin = typeof window !== 'undefined' ? window.location.origin : '';
    this.selectedJobUrl = `${origin}/home/job/${item.id}`;
  }

  copyToClipboard(): void {
    // Check if clipboard API is available
    if (typeof navigator !== 'undefined' && navigator.clipboard) {
      navigator.clipboard
        .writeText(this.selectedJobUrl)
        .then(() => {
          alert('Enlace copiado al portapapeles');
        })
        .catch(() => {
          alert('Error al copiar el enlace');
        });
    } else {
      alert('La función de copiar no está disponible en este navegador');
    }
  }
}
